import { RatePlanTranslation } from "@/shared/models/ratePlanModel";
import { PaymentQueryViewModel } from "@/shared/models/payment"

export class OwnerModel {
    id = 0;
    name = "";
    email = "";
    telephoneNumber = "";
}

export class ReservationCustomerModel {
    id = 0;
    name = "";
    eMail = "";
    telephoneNumber = "";
    countryOfResidenceId: number | undefined = undefined;
    isLegalEntity = false;
    identificationNumber = "";
    status = false;
}

export class ReservationGuestModel extends ReservationCustomerModel {
    reservationsAccUnitTypeGuestId = 0;
    checkInDate?: Date;
    checkOutDate?: Date;
    isCheckedIn = false;
    isCheckedOut = false;
    isEVisitorCheckedIn = false;
    isEVisitorCheckedOut = false;
    isRoomHolder = false;
    city?: string;
    dateOfBirth?: Date | string;
    eVisitorCheckInDate?: Date;
    eVisitorCheckOutDate?: Date;
    menuShown = false;
}

export class ReservationGuestUpdateFeedbackModel {
    isSuccessful = true;
    guestsWithErrors: ReservationGuestWithErrorsModel[] = [];
}

export class ReservationGuestWithErrorsModel {
    guestName = "";
    errorMessage = "";
}

export class ReservationModel {
    id = 0;
    currencyId: number | null = null;

    // holder and sales channel
    customerId = 0;
    customer = new ReservationCustomerModel();
    distributionChannelTypeId = 0;
    salesChannelId: number | null = null;
    otaid: number | null = null;
    otareservationId = "";
    isChannexIdPresent = false;
    hasSavedCreditCard = false;
    bookingDate = new Date().toISOString().substr(0, 10);

    paymentMeansId: number | null = null;
    paymentMeanBaseId: number | null = null;
    cardTypeId: number | null = null;

    // stay period
    arrivalDate: Date | null = null;
    departureDate: Date | null = null;
    statusId = 1;
    optionExpirationDate: string | null = null;

    numberOfAdults?: number = 0;
    numberOfChildren?: number = 0;
    numberOfPets?: number = 0;
    numberOfUnits?: number = 0;

    childrenAges?: number[] = [];

    // units
    accomodationUnitTypes: ReservationAccUnitModel[] = [];
    originalUnitTypesReservationWasOpenedWith: ReservationAccUnitModel[] = [];

    // remarks
    guestRemarks = "";
    propertyStaffRemarks = "";
    remarksForOwner = "";
    maintenanceStaffRemarks = "";
    tags: string[] = [];

    colorCodeHex = null as string | null;

    hasCancelationOverride = false;
    hasPrepaymentOverride = false;

    isManualSalesChannelChanged = false;

    isOTACollect = false;

    invoiceStatusId: number | null = null;
    amountToInvoice: number | null = null;
    totalPaidByGuest = 0;
}

export class ReservationAccUnitModel {
    id = 0;
    statusId?: number = undefined;
    reservationId = 0;
    isInvoiced = false;
    isInvoicedForOwner = false;

    accomodationUnitTypeId = 0;

    propertyId?: number = undefined;
    propertyPaysVat?: boolean = undefined;
    city?: string;
    propertyDefaultBusinessUnitId?: number = undefined;
    checkOutTimeUntil = "";

    agencyWorkModelId?: number = undefined;
    vatCategoryForPrepayments?: number = undefined;
    vatCategoryForPrepaymentTaxRateId?: number = undefined;
    ownerPaysVAT = false;
    ownerIsLegalEntity = false;
    ownerId?: number = undefined;
    ownerIsResident = false;
    ownerVatId = "";

    unitPaysCityTax?: boolean = undefined;
    propertyOwner = new OwnerModel();
    unitOwner = new OwnerModel();
    propertyManager = new OwnerModel();
    accomodationUnitId?: number = undefined;
    occupancyBasedRuleId?: number = undefined;

    ratePlan?: SelectedRatePlanModel = undefined;
    ratePlansAccomodationUnitTypeId?: number = undefined;

    arrivalDate = "";
    departureDate = "";
    numberOfNights = 0;
    expectedArrivalTime: string | null = null;
    expectedDepartureTime: string | null = null;

    numberOfAdults = 0;
    numberOfChildren = 0;
    numberOfPets = 0;
    childrenAges: number[] = [];

    guests: ReservationGuestModel[] = [];

    selectedServices: AddOnServiceModel[] = [];
    ownerAddOnServicesPrice?: number = undefined;
    ownerAccommodationPrice?: number = undefined;
    ownerTotalPrice?: number = undefined;

    translations: ReservationAccUnitTranslation[] = [];

    // available options (services, units, rate plans, obrs, serviceTypes)
    availableServices: AddOnServiceModel[] = [];
    accomodationUnitOptions: AccomodationUnitModel[] = [];
    ratePlanOptions: RatePlanModel[] = [];
    agencyFeesTotal: number | null = null;
    propertyAgencyFees: ReservationAgencyFeeModel[] = [];
    appliedAgencyFees: ReservationAgencyFeeModel[] = [];

    // price
    discountPercent: number | null = null;
    discountInputPercent: number | null = null;
    dayPrices: {
        date: Date;
        price: number;
        inputPrice: number;
        inputPriceBeforeCommission: number;
        serviceTypeId?: number | undefined;
        mergedCityTaxAmount: number;
    }[] = [];
    pricePerNight: number | null = null;
    userSetPricePerNightManually = false;

    currentDayPrices: {
        date: Date;
        price: number;
        ratePlanAccomodationUnitTypeId: number;
        occupancyBasedRuleId?: number;
    }[] = [];

    // rack rates
    officialRates: ReservationAccomodationUnitTypeOfficialRateModel[] = [];

    // display info
    propertyName = "";
    propertyCheckoutTimeUntil = "";
    accomodationUnitTypeName = "";
    accomodationUnitName = "";
    accomodationUnitStatus?: number = undefined;

    maxNumberOfAdults = 0;
    maxNumberOfChildren = 0;
    maxOccupancy = 0;
    allowedOccupancy = 0;

    damageDeposit?: number | "";
    depositCurrencyId?: number;

    channelCommission: number | null = null;
    channelCommissionPercent: number | null = null;
    ownerPaysOTACommission = false;
    inputPriceWasManuallyChanged = false;

    maintenanceStaffRemarks = "";
    guestPlaceholder: string | null = null;

    manuallyChangedRatePlan = false;
}

export interface AddOnServiceModel {
    id: number;
    addOnServiceId: number;
    name: string;

    isInvoiced: boolean;

    netUnitPrice: number;
    quantity: number;
    decimalQuantity: number;
    defaultQuantity: number;
    grossPrice: number;
    grossUnitPrice: number;
    discountPercent: number;
    taxRateId: number;
    consumptionTaxRate: number | null;
    calculationMethodId: number;
    currencyId: number;
    taxExemptionReason: string;

    unitOfMeasureId: number;

    isIncludedInPrice: number;
    isCityTax: boolean;
    isBookingFee: boolean;
    isTransfer: boolean;
    isFee: boolean;
    isFoodAndBeverages: boolean;
    isRelative: boolean;
    isEditedManually: boolean;
    isAddedAutomatically: boolean;
    mergeToAccommodationWhenInvoicing: boolean;
    pricesAreSeasonal: boolean;

    from: string;
    to: string;
    periods: AddOnServiceModelPeriod[];
    serviceDateFrom: string | null;
    serviceDateTo: string | null;
    serviceRange: (string | null)[];
    idx: number;

    ownerPayoutAmount?: number | null;
    ownerPayoutIsAbsolute?: boolean;

    isPPOM: boolean;
    ppomTaxCategoryId?: number;
    isOTASpecific: boolean;
}

export interface AddOnServiceModelPeriod {
    from: string;
    to: string;
    amount: number;
    ownerPayoutSeasonal?: number | null;
    ownerPayoutSeasonalIsAbsolute?: boolean;
}

export interface AccomodationUnitModel {
    id: number;
    name: string;
    ownerId: number | null;
}

export interface SelectedRatePlanModel {
    id: number;
    ratePlansAccomodationUnitTypeId: number;
    parentRatePlanId?: number;
    name: string;
    currencyId: number;
    isDefault: boolean;
    minStay?: number;
    maxStay?: number;
    minPersons?: number;
    maxPersons?: number;
    losCategoryId: number | null;
    paxCategoryId: number | null;
    accomodationBookingFee: number | null;
    addOnServicesBookingFee: number | null;
    mergeAllBookingFeesIntoSingleItem: boolean;
}

export interface RatePlanModel {
    id: number;
    ratePlanId: number;
    name: string;
    isDerived: boolean;
    parentRatePlanId?: number;
    currencyId: number;
    translations: RatePlanTranslation[];
    isDefault: boolean;
    minStay: number;
    maxStay: number;
    minPersons: number;
    maxPersons: number;
    losCategoryId: number | null;
    paxCategoryId: number | null;
    dayPrices: {
        date: Date;
        price: number;
        inputPrice: number;
        inputPriceBeforeCommission: number;
        serviceTypeId?: number;
        mergedCityTaxAmount: number;
    }[];
    defaultServiceTypeId?: number;
    status: boolean;
    accomodationBookingFee: number | null;
    addOnServicesBookingFee: number | null;
    mergeAllBookingFeesIntoSingleItem: boolean;
}

export interface OccupancyBasedRuleModel {
    id: number;
    numberOfOccupants: number;
    priceDifference: number;
    priceDifferenceIsAbsolute: boolean;
}

export interface SearchRestrictionsModel {
    period: Date[];
    numberOfUnits?: number;
    numberOfAdults?: number;
    numberOfChildren?: number;
    numberOfBedrooms?: number;
    numberOfBathrooms?: number;
    childrenAges?: number[];
    isFromCalendar?: boolean;
    isFromAvailabilitySearch?: boolean;
}

export interface UnitAvailability {
    accomodationUnitTypeId: number;
    numberOfSelectedUnits: number;
    numberOfAvailableUnits: number;
}

export interface PropertyOtaView {
    commissionPercent: number;
    paymentCollectByOTA: boolean;
    ownerPaysOTACommission: boolean;
}

export class GuestModel {
    id: number | null = null;
    reservationsAccUnitTypeGuestId: number | null = null;
    isRoomHolder: boolean | false = false;
    constructor(id: number, reservationsAccUnitTypeGuestId: number, isRoomHolder: boolean) {
        this.id = id;
        this.reservationsAccUnitTypeGuestId = reservationsAccUnitTypeGuestId;
        this.isRoomHolder = isRoomHolder;
    }
}

export interface ReservationAccUnitTranslation {
    id: number;
    accomodationUnitTypeId: number;
    cultureCode: string;
    nameTranslation: string;
}

export interface ReservationAccomodationUnitTypeOfficialRateModel {
    id: number;
    accomodationUnitTypeId: number;
    ratePlanId: number | null;
    serviceTypeId: number | null;
    dateFrom: string;
    dateTo: string;
    price: number;
    currencyId: number;
    isMain: boolean;
    officialRateOccupancyBasedRules: ReservationAccomodationUnitTypeOfficialRateOBRModel[];
}

export interface ReservationAccomodationUnitTypeOfficialRateOBRModel {
    id: number;
    accomodationUnitTypeOfficialRateId: number;
    price: number;
    minStay?: number;
    maxStay?: number;
    minPersons?: number;
    maxPersons?: number;
    losCategoryId: number | null;
    paxCategoryId: number | null;
}

// models used for create/update requests (stripped of needless properties)
export class ReservationRequestModel {
    constructor(reservation: ReservationModel) {
        this.id = reservation.id;
        this.customerId = reservation.customerId;
        this.distributionChannelTypeId = reservation.distributionChannelTypeId;
        this.salesChannelId = reservation.salesChannelId;
        this.bookingDate = reservation.bookingDate;
        this.paymentMeansId = reservation.paymentMeansId;
        this.paymentMeanBaseId = reservation.paymentMeanBaseId;
        this.cardTypeId = reservation.cardTypeId;
        this.arrivalDate = reservation.arrivalDate;
        this.departureDate = reservation.departureDate;
        this.statusId = reservation.statusId;
        this.optionExpirationDate = reservation.optionExpirationDate;
        this.numberOfAdults = reservation.numberOfAdults;
        this.numberOfChildren = reservation.numberOfChildren;
        this.numberOfPets = reservation.numberOfPets;
        this.numberOfUnits = reservation.numberOfUnits;
        this.guestRemarks = reservation.guestRemarks;
        this.propertyStaffRemarks = reservation.propertyStaffRemarks;
        this.remarksForOwner = reservation.remarksForOwner;
        this.maintenanceStaffRemarks = reservation.maintenanceStaffRemarks;
        this.tags = reservation.tags;
        this.otaid = reservation.otaid;
        this.isOTACollect = reservation.isOTACollect;
        this.colorCodeHex = reservation.colorCodeHex;

        this.accomodationUnitTypes = reservation.accomodationUnitTypes.map(x => ({
            id: x.id,
            statusId: x.statusId,
            accomodationUnitTypeId: x.accomodationUnitTypeId,
            accomodationUnitId: x.accomodationUnitId,
            ratePlanId: x.ratePlan?.id,
            ratePlansAccomodationUnitTypeId: x.ratePlan?.ratePlansAccomodationUnitTypeId,
            manuallyChangedRatePlan: x.manuallyChangedRatePlan,
            occupancyBasedRuleId: x.occupancyBasedRuleId,
            arrivalDate: x.arrivalDate,
            departureDate: x.departureDate,
            expectedArrivalTime: x.expectedArrivalTime,
            expectedDepartureTime: x.expectedDepartureTime,
            numberOfAdults: x.numberOfAdults,
            numberOfChildren: x.numberOfChildren,
            numberOfPets: x.numberOfPets,
            childrenAges: x.childrenAges,
            guests: x.guests.map(g => new GuestModel(g.id, g.reservationsAccUnitTypeGuestId, g.isRoomHolder)),
            discountPercent: x.discountPercent,
            discountInputPercent: x.discountInputPercent,
            dayPrices: x.dayPrices,
            ownerPaysOTACommission: x.ownerPaysOTACommission,
            inputPriceWasManuallyChanged: x.inputPriceWasManuallyChanged,
            pricePerNight: x.pricePerNight,
            userSetPricePerNightManually: x.userSetPricePerNightManually,
            selectedServices: x.selectedServices,
            damageDeposit: x.damageDeposit === "" ? undefined : x.damageDeposit,
            depositCurrencyId: x.depositCurrencyId,
            channelCommission: x.channelCommission,
            channelCommissionPercent: x.channelCommissionPercent,
            maintenanceStaffRemarks: x.maintenanceStaffRemarks ?? null,
            guestPlaceholder: x.guestPlaceholder ?? null,
            hasChanges: true
        }));
    }

    id = 0;

    // holder and sales channel
    customerId = 0;
    distributionChannelTypeId = 0;
    salesChannelId: number | null = null;
    bookingDate = new Date().toISOString().substr(0, 10);

    paymentMeansId: number | null = null;
    paymentMeanBaseId: number | null = null;
    cardTypeId: number | null = null;
    otaid: number | null = null;

    isOTACollect: boolean | false;

    // stay period
    arrivalDate: Date | null = null;
    departureDate: Date | null = null;
    statusId = 1;
    optionExpirationDate: string | null = null;

    numberOfAdults?: number = 0;
    numberOfChildren?: number = 0;
    numberOfPets?: number = 0;
    numberOfUnits?: number = 0;

    // units
    accomodationUnitTypes: ReservationAccUnitRequestModel[] = [];

    // remarks and tags
    guestRemarks = "";
    propertyStaffRemarks = "";
    remarksForOwner = "";
    maintenanceStaffRemarks = "";
    tags: string[] = [];

    colorCodeHex: string | null = null;
}

export class ReservationAccUnitRequestModel {
    id = 0;
    statusId?: number = undefined;

    accomodationUnitTypeId = 0;

    accomodationUnitId?: number = undefined;
    ratePlanId?: number = undefined;
    ratePlansAccomodationUnitTypeId?: number = undefined;
    occupancyBasedRuleId?: number = undefined;

    arrivalDate = "";
    departureDate = "";

    expectedArrivalTime: string | null = null;
    expectedDepartureTime: string | null = null;

    numberOfAdults = 0;
    numberOfChildren = 0;
    numberOfPets = 0;
    childrenAges: number[] = [];
    guests: GuestModel[] = [];

    // price
    discountPercent: number | null = null;
    discountInputPercent: number | null = null
    dayPrices: {
        date: Date;
        price: number;
    }[] = [];
    pricePerNight: number | null = null;
    userSetPricePerNightManually = false;

    selectedServices: AddOnServiceModel[] = [];

    damageDeposit?: number;
    depositCurrencyId?: number;

    channelCommission: number | null = null;
    channelCommissionPercent: number | null = null;

    maintenanceStaffRemarks: string | null = null;

    hasChanges = true;
}

export class PaymentModel {
    constructor() {
        const today = new Date();
        this.paymentDate = today.toISOString();
    }

    id: number | null = null;
    customerName: string | null = null;
    customerId: number | null = null;
    paymentDate = "";
    amount: number | null = null;
    currencyId: number | null = null;
    paymentMeansId: number | null = null;
    paymentMeanBaseId: number | null = null;
    cardTypeId: number | null = null;
    reservationId: number | null = null;
    financialDocumentId: number | null = null;
    financialDocumentStatusId: number | null = null;
    financialDocumentTypeId: number | null = null;
}

export class PaymentSlipModel {
    constructor(
        public documentTypeId: number,
        public businessUnitId: number | null,
        public cashRegisterId: number | null,
    ) {
        const today = new Date();
        this.id = null,
            this.documentTypeId = documentTypeId,
            this.transactionDate = today.toISOString().substring(0, 10);
        this.transactionTime = new Date(
            Date.UTC(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                today.getHours(),
                today.getMinutes()
            )
        ).toISOString().substring(11, 16),
            this.documentNumber = "",
            this.customerId = null,
            this.amount = 0,
            this.currencyId = null,
            this.businessUnitId = businessUnitId,
            this.cashRegisterId = cashRegisterId,
            this.transactionDescriptionId = null,
            this.additionalNoteForTransaction = "",
            this.customerName = ""
    }

    id: number | null = null;
    transactionDate = "";
    transactionTime = "";
    cashierId: number | null = null;
    documentNumber = "";
    documentInternalIdentifier = "";
    documentIdentifier = "";
    amount = 0;
    currencyId: number | null = null;
    transactionDescriptionId: number | null = null;
    additionalNoteForTransaction = "";
    customerId: number | null = null;
    customerName = "";
}


export enum DistributionChannelTypesEnum {
    OTA = 1,
    WalkIn = 2,
    Telephone = 3,
    Email = 4,
    Website = 5,
    Facebook = 6,
    PartnerAgency = 7,
    OTAConversion = 10,
    OwnersReservation = 11
}

export type ChangeRatePlanEvent = {
    ratePlansAccomodationUnitTypeId: number;
    updateOtherUnits: boolean;
    autoPriceRecalculation: boolean;
    inputPriceRecalculationOnly: boolean;
};

export type AddRatePlanEvent = {
    ratePlanId: number;
}

export type NotifyUnitEvent = {
    model: ReservationAccUnitModel;
    updateOtherUnits: boolean;
    autoPriceRecalculation: boolean;
    inputPriceRecalculationOnly: boolean;
}

export type ChangeServiceTypeEvent = {
    serviceTypeId: number;
    updateOtherUnits: boolean;
};

export type PayByLinkPrepayment = {
    dueDate: Date;
    amount: number;
    currencyId: number;
}

export class PayByLinkInfoModel {
    prepayments: PayByLinkPrepayment[] = [];
    payments: PaymentQueryViewModel[] = [];
    isPossibleToChargeCreditCard = false;
}

export interface ReservationAgencyFeeModel {
    agencyFeeId: number;
    propertyId: number;
    name: string;
    amount: number;
    currencyId: number;
    calculationMethodId: number;
    priceIsAbsolute: boolean;
    reservationAccUnitTypeId: number;
}